import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MembershipPlanModel } from 'src/app/admin-panel/models/business/membership-plan.model';

@Component({
  selector: 'app-add-or-edit-membership-plans',
  templateUrl: './add-or-edit-membership-plans.component.html',
  styleUrls: ['./add-or-edit-membership-plans.component.scss']
})
export class AddOrEditMembershipPlansComponent implements OnInit {

  //#region Fields
  public membershipPlanId: string;
  public membershipPlanModel: MembershipPlanModel;
  public enableEdit: boolean = false;
  //#endregion
  //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.membershipPlanModel = new MembershipPlanModel();
    if (this.config.data != undefined && this.config.data.id) {
      this.membershipPlanId = this.config.data.id;
      this.membershipPlanModel = this.config.data.model;     
    }
  }

  ngOnInit(): void {
  }
  //#endregion
  //#region Public Methods
  saveMembershipPlan(model: MembershipPlanModel) {

  }
  editMembershipPlan(model: MembershipPlanModel) {

  }
  cancel() {
    this.ref.close(true)
  }
  //#endregion
  //#Private Methods
  //#endregion
}
